import { useCallback, useState } from 'react';

import type { ImageData } from '../types/pdf.types';

export const usePDFImageState = () => {
  const [images, setImages] = useState<ImageData[]>([]);

  const handleImageDelete = useCallback((imageId: string) => {
    setImages((prev) => prev.filter((img) => img.id !== imageId));
  }, []);

  const handleImagePositionChange = useCallback(
    (imageId: string, x: number, y: number) => {
      setImages((prev) =>
        prev.map((img) =>
          img.id === imageId ? { ...img, position: { x, y } } : img,
        ),
      );
    },
    [],
  );

  const handleImageSizeChange = useCallback(
    (imageId: string, width: number, height: number) => {
      setImages((prev) =>
        prev.map((img) =>
          img.id === imageId ? { ...img, size: { width, height } } : img,
        ),
      );
    },
    [],
  );

  return {
    images,
    setImages,
    handleImageDelete,
    handleImagePositionChange,
    handleImageSizeChange,
  };
};
